import { DrawerCollapsible } from "components/UI/DrawerCollapsible/DrawerCollapsible.tsx";
import { FC, ReactNode } from "react";

interface AccountSettingsCollapsibleCardProps {
    children: ReactNode;
    title: ReactNode;
}

export const AccountSettingsCollapsibleCard: FC<AccountSettingsCollapsibleCardProps> = ({ children, title }) => (
    <DrawerCollapsible
        title={title}
        isDefaultOpen={false}
        wrapperClassName="!p-0"
        className="!p-5 [&_.ant-collapse-header]:!p-0 [&_.ant-collapse-content-box]:!px-0 [&_.ant-collapse-content-box]:!pb-0"
    >
        {children}
    </DrawerCollapsible>
);
